export class opportunityScannerFilterConfig {
  static bedBathDropdownValues = [1, 2, 3, 4, 5, 6];
  static propertySubTypeEnum: Record<string, string> = {
    apt: 'Apartment',
    condo: 'Condominium',
    landMfd: 'Manufactured On Land',
    mfd: 'Manufactured Home',
    mobile: 'Mobile Home',
    multi: 'Multi Family',
    multiLarge: 'Multi Family > 4',
    quad: 'Quadruplex',
    single: 'Single Family Residence',
    town: 'Townhouse',
    land: 'Land',
    duplex: 'Duplex',
    triplex: 'Triplex',
  };

  static minLivingAreaOptions = [
    { label: '500 sqft', value: 500 },
    { label: '750 sqft', value: 750 },
    { label: '1,000 sqft', value: 1000 },
    { label: '1,250 sqft', value: 1250 },
    { label: '1,500 sqft', value: 1500 },
    { label: '1,750 sqft', value: 1750 },
    { label: '2,000 sqft', value: 2000 },
    { label: '2,250 sqft', value: 2250 },
    { label: '2,500 sqft', value: 2500 },
    { label: '2,750 sqft', value: 2750 },
    { label: '3,000 sqft', value: 3000 },
    { label: '3,500 sqft', value: 3500 },
    { label: '4,000 sqft', value: 4000 },
    { label: '5,000 sqft', value: 5000 },
    { label: '6,000 sqft', value: 6000 },
  ];
  static maxLivingAreaOptions = [
    { label: '750 sqft', value: 750 },
    { label: '1,000 sqft', value: 1000 },
    { label: '1,250 sqft', value: 1250 },
    { label: '1,500 sqft', value: 1500 },
    { label: '1,750 sqft', value: 1750 },
    { label: '2,000 sqft', value: 2000 },
    { label: '2,250 sqft', value: 2250 },
    { label: '2,500 sqft', value: 2500 },
    { label: '2,750 sqft', value: 2750 },
    { label: '3,000 sqft', value: 3000 },
    { label: '3,500 sqft', value: 3500 },
    { label: '4,000 sqft', value: 4000 },
    { label: '5,000 sqft', value: 5000 },
    { label: '6,000 sqft', value: 6000 },
    { label: '7,000 sqft', value: 7000 },
  ];

  static valuationOptions: string[] = ['Single Family Residence', 'Condominium', 'Multi Family'];

  static propertyTypeOptions: string[] = [
    'Single Family Residence',
    'Townhouse',
    'Condominium',
    'Duplex',
    'Triplex',
    'Quadruplex',
    'Multi Family',
    'Multi Family >= 5',
  ];

  static propertyTypeMapping: { [key: string]: string[] } = {
    'Single Family Residence': ['Single Family Residence', 'Townhouse'],
    'Condominium': ['Condominium'],
    'Multi Family': ['Duplex', 'Triplex', 'Multi Family', 'Multi Family >= 5', 'Quadruplex'],
    'sfrModel': ['Single Family Residence', 'Townhouse'],
    'condoModel': ['Condominium'],
    'multiFamilyModel': ['Duplex', 'Triplex', 'Multi Family', 'Multi Family >= 5', 'Quadruplex'],
    'Townhouse': ['Single Family Residence', 'Townhouse']
  };
}
